var _defs, _rect, _g, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIfcSiteReferencedSvg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #72a341;\n      }\n\n      .cls-2 {\n        fill: #363545;\n      }\n    "))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 30,
    width: 32,
    height: 2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "4.45 15.86 6.57 15.86 7.66 13.45 5.55 13.45 4.45 15.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "11.74 10.67 15.28 10.67 15.28 8.75 12.23 8.75 11.74 10.67"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "16.72 8.75 16.72 10.67 20.26 10.67 19.77 8.75 16.72 8.75"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "15.28 21.25 15.28 19.33 9.51 19.33 9.01 21.25 15.28 21.25"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "21.75 10.67 23.08 10.67 23.68 12.01 25.8 12.01 24.32 8.75 21.26 8.75 21.75 10.67"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "8.02 19.33 4.99 19.33 5.91 17.3 3.8 17.3 2 21.25 7.52 21.25 8.02 19.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "26.09 17.3 27.01 19.33 23.98 19.33 24.48 21.25 30 21.25 28.2 17.3 26.09 17.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "22.49 19.33 16.72 19.33 16.72 21.25 22.99 21.25 22.49 19.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "8.32 12.01 8.92 10.67 10.25 10.67 10.74 8.75 7.68 8.75 6.2 12.01 8.32 12.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "26.45 13.45 24.34 13.45 25.43 15.86 27.55 15.86 26.45 13.45"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M16.31,15.26c2.11-.34,5.85-1.39,7.54-4.74l-.89-.45c-1.92,3.81-7.15,4.29-8.04,4.34-.04-.02-.07-.04-.1-.06-3.8-2.36-7.99-.82-8.17-.75l.35.94s3.92-1.43,7.29.67c2.11,1.31,3.79,2.36,6.12,2.36,1.6,0,3.5-.5,6.06-1.74l-.44-.9c-4.9,2.39-7.03,1.88-9.7.34Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIfcSiteReferencedSvg);
export default __webpack_public_path__ + "static/media/IFCSiteReferenced_svg.51a14b39a7f547d15ea6001fb70bf2e7.svg";
export { ForwardRef as ReactComponent };